import { render, staticRenderFns } from "./Case1.vue?vue&type=template&id=c06acbb8&scoped=true&"
import script from "./Case1.vue?vue&type=script&lang=js&"
export * from "./Case1.vue?vue&type=script&lang=js&"
import style0 from "./Case1.vue?vue&type=style&index=0&id=c06acbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06acbb8",
  null
  
)

export default component.exports